import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';

export const menus = [
    {
        title: 'Atendimentos',
        icon: <SentimentVeryDissatisfiedIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardsamu/results',
    },
    {
        title: 'Chamados',
        icon: <SentimentVeryDissatisfiedIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardsamu/calls',
        gap: true
    },
    {
        title: 'Regulação',
        icon: <SentimentVeryDissatisfiedIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardsamu/regulation',
    }
];